import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/** <img> for API routes that need the bearer token — fetches a blob and shows it. */
export function AuthImg({ src, alt = '', className = '', onClick }) {
  const { api } = useAuth();
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true; let obj = null;
    setUrl(null); setFailed(false);
    api.get(src, { responseType: 'blob' }).then(r => { if (!alive) return; obj = URL.createObjectURL(r.data); setUrl(obj); }).catch(() => alive && setFailed(true));
    return () => { alive = false; if (obj) URL.revokeObjectURL(obj); };
  }, [api, src]);
  if (failed) return <div className={`${className} bg-white/5 text-gray-600 text-[10px] flex items-center justify-center`}>no image</div>;
  if (!url) return <div className={`${className} bg-white/5 flex items-center justify-center`}><Loader2 className="w-4 h-4 animate-spin text-gray-500" /></div>;
  return <img src={url} alt={alt} className={className} onClick={onClick} />;
}
